import s from './style.module.scss';
import { DoubleRightOutlined } from '@ant-design/icons';
const CardButton = (props) => {
    const { setShowCaseCard, expand } = props;

    const toggleExpand = () => {
        setShowCaseCard(!expand);
    };
    return (
        <div data-expand={expand} onClick={toggleExpand} className={s['card-button']} style={{ borderWidth: '1px' }}>
            <span className={s['card-button-text']}>{expand ? '收起' : '案例库'}</span>
            <span className={s['card-button-icon']}>
                <DoubleRightOutlined rotate={expand ? 90 : -90} />
            </span>
        </div>
    );
};
export default CardButton;
